<template>
  <div v-bind:class="{ 'start-screen-container': lightMode }">
    <div v-bind:class="{ 'content-container': !lightMode, 'content-container-light': lightMode }">
      <div class="title-container">
        <span class="pds-typography-h5 pds-typography-bold textTitle">Reconocimiento Facial</span>
      </div>
      <a @click="$emit('goBack')" class="fulfillment-link" v-bind:style="{ color: '#0061A0' }">
        <vue-feather type="arrow-left" size="24" stroke="#0061A0"></vue-feather> Volver
      </a>  
      <div class="info-container">
        <div class="info-box">
          <span class="pds-typography-h5 subtitle-container">Recuerda lo siguiente:</span>
          <div class="loading-steps-container">
            <div class="pds-typography-body-16 step-information-container">
              <span class="icon-container">
                <vue-feather type="check-circle" size="22" stroke-width="2" stroke="#0061a0"></vue-feather>
              </span>
              <span v-bind:class="{ message: !lightMode, 'message-light': lightMode }">
                Busca tu
                <span class="pds-typography-bold">cédula de identidad válida</span>
              </span>
            </div>
            <div v-if="!mobile" class="pds-typography-body-16 step-information-container">
              <span class="icon-container">
                <vue-feather type="check-circle" size="22" stroke-width="2" stroke="#0061a0"></vue-feather>
              </span>
              <span v-bind:class="{ message: !lightMode, 'message-light': lightMode }">
                Busca tu
                <span class="pds-typography-bold">teléfono móvil</span>
              </span>
            </div>
            <div class="pds-typography-body-16 step-information-container">
              <span class="icon-container">
                <vue-feather type="check-circle" size="22" stroke-width="2" stroke="#0061a0"></vue-feather>
              </span>
              <span v-bind:class="{ message: !lightMode, 'message-light': lightMode }">
                Tienes
                <span class="pds-typography-bold">15 minutos</span>
                para completar los pasos
              </span>
            </div>
            <button class="pds-button startButton" v-on:click="$emit('start-screen-next-step')">
              <div class="textButtonBox">
                <span class="textButton">Iniciar reconocimiento facial</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueFeather from "vue-feather";

export default {
  name: "StartScreen",
  components: {
    VueFeather,
  },
  props: {
    lightMode: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false },
  },
};
</script>

<style scoped src="@pds/typography/typography.min.css"></style>
<style scoped src="@pds/button/button.min.css"></style>
<style scoped>
/*noinspection CssUnusedSymbol*/

.textTitle {
  box-sizing: border-box;
  padding: 0;
  margin: 0 0 5px;
  font-weight: bolder;
  color: #464646;
  display: block;
  line-height: 30px;
}

.icon-container {
  margin-bottom: -3px;
}

.info-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-radius: 5px;
  min-width: 300px;
  max-width: 640px;
  width: 100%;
  height: 320px;
  margin-top: 12px;
}

.startButton {
  background-color: #0061a0;
  width: 100%;
  max-width: 300px;
  min-width: 275px;
  margin-top: 20px;
  border: none;
  min-height: 50px;
  padding: 14px 24px;
  border-radius: 28px;
  display: block;
  font-size: 17px;
  line-height: 21px;
  font-weight: bold;
}

.step-information-container {
  display: flex;
  padding: 6px 0;
}

.start-screen-container {
  height: inherit;
}

.content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 645px;
  margin: auto;
  padding: 3em 0;
  width: 90%;
}

.content-container-light {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  max-width: 645px;
  margin: auto;
  height: inherit;
}

.message {
  width: 100%;
  max-width: calc(500px + 3em);
  padding: 0 9px;
  align-self: center;
  box-sizing: border-box;
  font-weight: 400;
  color: #464646;
  display: block;
  font-size: 17px;
}

.message-light {
  width: 100%;
  max-width: calc(500px + 5em);
  text-align: left;
}

.title-container {
  margin-bottom: 1.5em;
  text-align: center;
  color: #333333;
  max-width: 645px;
}

.subtitle-container {
  padding-bottom: 1em;
  color: #333333;
  line-height: 27px;
  text-align: left;
}

.border-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(161, 161, 161, 0.603);
  border-radius: 6px;
  padding: 2.25em 1.5em;
  margin-top: 0.75em;
  max-width: 500px;
}

.border-container-light {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.75em;
}

.info-box {
  display: flex;
  flex-direction: column;
}

.fulfillment-link {
  color: #0091da;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
}

.textButton {
  font: inherit;
  color: #fff;
  text-transform: inherit;
  display: block;
}
@media only screen and (max-width: 700px) {
  .info-box {
    width: 90%;
  }
  .subtitle-container {
    text-align: center;
  }
}
</style>
